import {
  useRef, useState, useLayoutEffect, useEffect,
} from 'react';
import { IconBase as Icon } from 'library/styles/icon';
import { Header5 } from 'library/styles/text';
import { LoaderBox } from 'library/components/entity-loader/loader-box';
import { Preview, StyledLoader } from './styles';

// eslint-disable-next-line no-unused-vars
const Upload = ({
  name, onUpload, isLoading, value,
}) => {
  const imageRef = useRef(null);
  const [file, setFile] = useState(null);
  const [isFileOver, setFileOver] = useState(false);

  useLayoutEffect(() => {
    if (file) {
      imageRef.current.src = file;
    }
  }, [file]);

  useEffect(() => {
    if (!value?.length) {
      if(imageRef.current) {
        imageRef.current.src = null;
      }

      setFile(null);
    }
  }, [value]);

  const dropHandler = (event) => {
    event.preventDefault();

    if (event.dataTransfer.items) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < event.dataTransfer.items.length; i++) {
        if (event.dataTransfer.items[i].kind === 'file') {
          // eslint-disable-next-line no-shadow
          let item = event.dataTransfer.items[i].getAsFile();

          if(item?.name.endsWith('.jpeg')) {
            item = new File([item], item.name.replace('.jpeg', '.jpg'), { type: item.type });
          }

          if(['.jpeg', '.jpg', '.gif', '.webp', '.png'].some((extension) => item.name?.toLowerCase()?.endsWith(extension))) {
            const data = URL.createObjectURL(item);
            onUpload(item);

            setFile(data);
          } else {
            event.dataTransfer.items.clear();
          }
        }
      }

      setFileOver(false);
    }
  };

  const dragOutHandler = (event) => {
    event.preventDefault();

    setFileOver(false);
  };

  const dragOverHandler = (event) => {
    event.preventDefault();

    setFileOver(true);
  };

  const handleChange = (event) => {
    event.preventDefault();

    if (event.target.files?.length) {
      if(event.target.files[0].name.endsWith('.jpeg')) {
        const myNewFile = new File([event.target.files[0]], event.target.files[0].name.replace('.jpeg', '.jpg'), { type: event.target.files[0].type });

        onUpload(myNewFile);

        setFile(URL.createObjectURL(myNewFile));
      } else {
        onUpload(event.target.files[0]);

        setFile(URL.createObjectURL(event.target.files[0]));
      }
    }

    setFileOver(false);
  };

  return (
    <Preview
      onDrop={dropHandler}
      onDragOver={dragOverHandler}
      onDragLeave={dragOutHandler}
      onMouseOut={dragOutHandler}
      isFileOver={isFileOver}
      isEmpty={!file}
      isLoading={isLoading}
    >
      {
        !file ? (
          <>
            <Icon className="icon-cloud-upload" size={90} />
            <Header5>Drag and Drop image here, or click to browse from your Computer</Header5>
          </>
        ) : <img ref={imageRef} alt="upload preview" />
      }
      {
        // eslint-disable-next-line max-len
        isLoading ? <StyledLoader><LoaderBox height={60} isAbsolute /></StyledLoader> : null
      }
      <input type="file" name={name} onChange={handleChange} hidden accept=".jpg, .jpeg, .gif, .png, .webp" />
      {/* <input type="hidden" name={name} /> */}
    </Preview>
  );
};

export default Upload;
